import { render, staticRenderFns } from "./ArticlesSliderItem.vue?vue&type=template&id=cb548b30&scoped=true&"
import script from "./ArticlesSliderItem.vue?vue&type=script&lang=js&"
export * from "./ArticlesSliderItem.vue?vue&type=script&lang=js&"
import style0 from "./ArticlesSliderItem.vue?vue&type=style&index=0&id=cb548b30&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb548b30",
  null
  
)

export default component.exports